import api from "../../../core/api/config";

export const buscarEdicaoPaciente = (pacienteId) => {
	return api.get(`/api/tracking/patient/${pacienteId}/edicao`);
};

export const buscarHistoricoInteracoes = (pacienteId) => {
	return api.get(`/api/tracking/interacoes/pessoa/${pacienteId}`);
};

export const processarPaciente = (pacienteId) => {
	return api.post(`/api/tracking/processamento/paciente/${pacienteId}`);
};

export default {
	buscarEdicaoPaciente,
	buscarHistoricoInteracoes,
	processarPaciente,
};
